<template>
  <div>
    <yxt-switch
      v-model="getValue"
      :active-value="1"
      :inactive-value="0"
      @change="switchWaterMarkChange"
      v-bind="$attrs.attrs"
      v-on="$attrs.on"
    ></yxt-switch>
    <span class="tlive-create__switch--text tlive-create__tip">
      {{
        $t(
          'pc_biz_displayWaterMark' /* 开启后，观看直播或回放时将显示访录屏水印 */
        )
      }}
    </span>
  </div>
</template>
<script>
import { setWatermarkConfig } from '../services/http';
export default {
  name: 'LiveWatermark',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  computed: {
    getValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    // 开关 水印
    switchWaterMarkChange(val) {
      // 如果打开水印需要判断［平台运营］是否设置水印规则，没有提示一下
      if (val) {
        setWatermarkConfig().then(res => {
          if (res.enabled === 0) {
            this.$message({
              message: `${this.$t(
                'pc_biz_setWaterMarkContent',
                /* 请前往［平台运营］设置水印规则，否则无法显示水印内容
                 */
              )}`
            });
          }
        });
      }
    }
  }
};
</script>
<style scoped lang="less"></style>
